import styled from "styled-components";

export const NavigationList = styled.ul`
    align-items: center;
    border-bottom: 5px double black;
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 1rem 8rem;

    a {
        color: #7f7f7f;
    }

    a:hover {
        color: black;
    }

    .active-nav {
        color: black;
        font-weight: bold;
    }

    @media(max-width: 600px) {
        padding: 1rem 5rem;
    }

    @media(max-width: 480px) {
        padding: 1rem 3rem;
    }

    @media(max-width: 400px) {
        padding: 1rem 1rem;
    }

    @media(amx-width: 330px) {
        padding: 1rem 0;
    }
    
    
    @media(max-width: 313px) {
        flex-direction: column;
        margin-bottom: 1.2rem;
    }
`;